module.exports = __webpack_public_path__ + "static/img/img_card_3d.07ea9bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mall/img_card_3d.png
// module id = PkXA
// module chunks = 1